//External libs
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

//Local libs
import Service from 'src/app/common/service';
import { ApiArrayModel } from 'src/app/common/model';
import ContinuousWaterMonitoringModel from './continuous-monitoring.model';

@Injectable({
  providedIn: 'root'
})
export class ContinuousWaterReadingsService extends Service<ContinuousWaterMonitoringModel> {

  public ongoingRequests: Subscription[] = [];

  constructor(public httpClient: HttpClient) {
    super(httpClient, '/device');
  }

  public getContinuousWaterReadings(deviceSerialNumber: string) {
    return new Promise<Array<ContinuousWaterMonitoringModel>>((resolve, reject) => {
      const request = this.httpClient.post<ApiArrayModel<ContinuousWaterMonitoringModel>>(`${this.imagebaseUrl}${this.serviceUrl}/continuousReadings`, {
        device_serial: deviceSerialNumber
      }, this.httpOptions).subscribe(response => {
        if (response.data) {
          response.data = response.data.map(item => {
            return {filename: response.filename, ...item};
          });
          resolve(response.data);
        }
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  //To Cancel the onGoing Http Requests
  public cancelOnGoingHttpRequests(): void {
    this.ongoingRequests.forEach((request) => {
      if (request && typeof request.unsubscribe === 'function') {
        request.unsubscribe();
      }
    });
    this.ongoingRequests = [];
  }
}
